import gql from 'graphql-tag';

import { WebGalleryAlbumCustomPrintDetails } from '../fragments/custom-prints';
import { PhotoUrlTypeFields } from '../fragments/global';

export const WebGalleryAlbumCustomPrintForCheckoutFromAlbum = gql`
  query webGalleryAlbumWithCustomPrintForCheckout($id: RecordID!) {
    album(id: $id) {
      id
      # Collages only for now.
      custom_prints(slice: { limit: 1 }, custom_print_types: [COLLAGE]) {
        records {
          ...WebGalleryAlbumCustomPrintDetails
        }
      }
    }
  }
  ${WebGalleryAlbumCustomPrintDetails}
`;

export const WebGalleryCustomPrintConfigurationPhotos = gql`
  query webGalleryCustomPrintConfigurationPhotos(
    $albumId: RecordID!
    $limit: Int = 50
    $albumPhotosOffset: Int = 0
    $favoritePhotosOffset: Int = 0
  ) {
    album(id: $albumId) {
      id
      photos(
        slice: { limit: $limit, offset: $albumPhotosOffset }
        for_web_gallery: true
      ) {
        total
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            ...PhotoUrlTypeFields
          }
        }
      }
      root_album_folder {
        id
        account_favorite_photos(
          slice: { limit: $limit, offset: $favoritePhotosOffset }
        ) {
          total
          records {
            id
            photo {
              id
              thumbnail_urls(ignore_watermark: true) {
                ...PhotoUrlTypeFields
              }
            }
          }
        }
      }
    }
  }
  ${PhotoUrlTypeFields}
`;
